import { render, staticRenderFns } from "./TableTab.vue?vue&type=template&id=47a1d1cc&scoped=true"
import script from "./TableTab.vue?vue&type=script&lang=js"
export * from "./TableTab.vue?vue&type=script&lang=js"
import style0 from "./TableTab.vue?vue&type=style&index=0&id=47a1d1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a1d1cc",
  null
  
)

export default component.exports